export function Create(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/ratings`;
}

export function Destroy(organizationID: number, ratingID: number): string {
	return `/v1/organizations/${organizationID}/user-ratings/${ratingID}`;
}

export function Show(organizationID: number, ratingID: number): string {
	return `/v1/organizations/${organizationID}/user-ratings/${ratingID}`;
}

export function ShowPrimaryRating(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/primary-rating`;
}

export function TogglePrimaryUserRating(organizationID: number, ratingID: number): string {
	return `/v1/organizations/${organizationID}/user-ratings/${ratingID}`;
}

export function UserIndex(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/ratings`;
}

